import { SxProps, Theme } from '@mui/material/styles';
import styled from 'styled-components';
import { colorPalette, device, getSpacing, typography } from 'stylesheet';

interface DrawerStyleProps {
  widthInPercent?: number;
  isMobile?: boolean;
  isTablet?: boolean;
}

export const getDrawerPaperSx = ({
  widthInPercent,
  isMobile,
  isTablet,
}: DrawerStyleProps): SxProps<Theme> => ({
  ...(isMobile
    ? {
        width: widthInPercent ? `${widthInPercent}vw` : '100vw',
        // iOS Safari: 100vh includes the area behind the browser toolbars, hiding the bottom of the panel
        height: '100vh',
        '@supports (height: 100dvh)': { height: '100dvh' },
        borderRadius: 0,
        paddingLeft: getSpacing(2),
        paddingRight: getSpacing(2),
        paddingTop: getSpacing(2),
        paddingBottom: `calc(${getSpacing(2)} + env(safe-area-inset-bottom, 0px))`,
        margin: 0,
      }
    : isTablet
      ? {
          width: '60vw',
          maxWidth: '80%',
          paddingLeft: getSpacing(4),
          paddingRight: getSpacing(4),
          paddingTop: getSpacing(2),
          paddingBottom: getSpacing(2),
        }
      : {
          ...(widthInPercent
            ? { width: `${widthInPercent}%` }
            : { minWidth: '40%', maxWidth: '60%' }),
          paddingLeft: getSpacing(5),
          paddingRight: getSpacing(5),
          paddingTop: getSpacing(2),
          paddingBottom: getSpacing(2),
        }),
  backgroundColor: colorPalette.backgroundMain,
  boxSizing: 'border-box',
});

export const SidePanelHeader = styled.div`
  min-height: ${getSpacing(11)};
  border-bottom: 1px solid ${colorPalette.grey_400};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  @media ${device.tabletMax} {
    min-height: ${getSpacing(7)};
  }
`;

export const TitleIconAndTitleContainer = styled.div`
  display: flex;
  align-items: center;
  ${typography.title_xsmall};
`;

export const TitleIconContainer = styled.div`
  width: ${getSpacing(5)};
  height: ${getSpacing(5)};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colorPalette.greyMain};
  @media ${device.tabletMax} {
    margin-right: ${getSpacing(3)};
  }
  margin-right: ${getSpacing(2)};
`;
